// UID: NPO-HOA-CAPEX-FILE
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2246
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import IsHOA from '../rules/IsHOA';
import { RulesetResult } from '../rules/';

class ReserveStudyRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isHoa = IsHOA.evaluate(data);
    return isHoa ? RulesetResult.OPTIONAL : RulesetResult.HIDDEN;
  };
}

export default new ReserveStudyRuleset();
